import React from 'react';
import PropTypes from 'prop-types';

export const ActivitiesImage = ({ iconName, background, width, height, fontSize, color }) => {
  return (
    <div
      style={{
        background,
        width,
        height,
        margin: 0,
        maxWidth: width,
        minWidth: width,
        maxHeight: height,
        minHeight: height,
        overflow: 'hidden',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <span className={iconName} style={{ fontSize, color }} />
    </div>
  );
};

ActivitiesImage.propTypes = {
  iconName: PropTypes.string,
  background: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string
};

ActivitiesImage.defaultProps = {
  iconName: 'hr-Plus',
  background: '#3b3f51',
  width: '42px',
  height: '42px',
  fontSize: '24px',
  color: '#fff'
};
